import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ServicesSection = ({ language }) => {
  const [openCategory, setOpenCategory] = useState('damen');
  const [openSubcategory, setOpenSubcategory] = useState('basis');

  const content = {
    de: {
      title: "Services & Preise",
      subtitle: "Transparente Preise für erstklassige Leistungen"
    },
    en: {
      title: "Services & Prices", 
      subtitle: "Transparent prices for first-class services"
    }
  };

  const services = {
    damen: {
      titleDE: "Damen",
      titleEN: "Ladies",
      subcategories: {
        basis: {
          titleDE: "Basis (Grundbehandlung)",
          titleEN: "Basic (Foundation Treatment)",
          services: [
            { 
              nameDE: "Waschen", 
              nameEN: "Wash", 
              price: "5€",
              sizes: "(K, M, L)"
            },
            { 
              nameDE: "Trocken", 
              nameEN: "Dry", 
              priceDE: "20€ (K) / 22€ (M) / 25€ (L)",
              priceEN: "20€ (S) / 22€ (M) / 25€ (L)"
            },
            { 
              nameDE: "Waschen, Föhnen, Legen", 
              nameEN: "Wash, Blow-dry, Style", 
              priceDE: "ab 20€ (K) / 22€ (M) / 25€ (L)",
              priceEN: "from 20€ (S) / 22€ (M) / 25€ (L)"
            },
            { 
              nameDE: "Waschen, Schneiden, Föhnen, Stylen", 
              nameEN: "Wash, Cut, Blow-dry, Style", 
              priceDE: "ab 30€ (K) / 34€ (M) / 38€ (L)",
              priceEN: "from 30€ (S) / 34€ (M) / 38€ (L)"
            },
            { 
              nameDE: "Haarkur", 
              nameEN: "Hair Treatment", 
              priceDE: "5€ (K) / 6€ (M) / 7€ (L)",
              priceEN: "5€ (S) / 6€ (M) / 7€ (L)"
            },
            { 
              nameDE: "Spülung", 
              nameEN: "Conditioning", 
              price: "3€"
            }
          ]
        },
        farbe: {
          titleDE: "Farbe / Strähnen",
          titleEN: "Color / Highlights",
          services: [
            { 
              nameDE: "Ansatzfarbe mit Packung", 
              nameEN: "Root Color with Package", 
              priceDE: "ab 38€",
              priceEN: "from 38€"
            },
            { 
              nameDE: "Komplett Färben mit Packung", 
              nameEN: "Complete Coloring with Package", 
              priceDE: "ab 40€ (K) / 45€ (M) / 50€ (L)",
              priceEN: "from 40€ (S) / 45€ (M) / 50€ (L)"
            },
            { 
              nameDE: "Tönung/Shake", 
              nameEN: "Toning/Shake", 
              priceDE: "ab 25€ (K) / 30€ (M) / 35€ (L) / 40€ (XL)",
              priceEN: "from 25€ (S) / 30€ (M) / 35€ (L) / 40€ (XL)"
            },
            { 
              nameDE: "Haubesträhnen", 
              nameEN: "Cap Highlights", 
              priceDE: "ab 30€ (K) / 40€ (M) / 50€ (L)",
              priceEN: "from 30€ (S) / 40€ (M) / 50€ (L)"
            },
            { 
              nameDE: "Foliensträhnen", 
              nameEN: "Foil Highlights", 
              priceDE: "ab 40€ (K) / 45€ (M) / 50€ (L)",
              priceEN: "from 40€ (S) / 45€ (M) / 50€ (L)"
            },
            { 
              nameDE: "Folien Strähnen 2 farbig", 
              nameEN: "Foil Highlights 2 Colors", 
              priceDE: "ab 45€ (K) / 55€ (M) / 60€ (L)",
              priceEN: "from 45€ (S) / 55€ (M) / 60€ (L)"
            },
            { 
              nameDE: "Kammsträhnen", 
              nameEN: "Comb Highlights", 
              priceDE: "ab 20€ (K) / 25€ (M) / 30€ (L)",
              priceEN: "from 20€ (S) / 25€ (M) / 30€ (L)"
            },
            { 
              nameDE: "Dauerwelle (W.Sch,F) mit Spülung", 
              nameEN: "Perm (W.Cut,B) with Conditioning", 
              priceDE: "ab 70€ (K) / 75€ (M) / 80€ (L)",
              priceEN: "from 70€ (S) / 75€ (M) / 80€ (L)"
            },
            { 
              nameDE: "Oberkopfdauerwelle (W.Sch.F) mit Spülung", 
              nameEN: "Top Head Perm (W.Cut.B) with Conditioning", 
              price: "60€"
            }
          ]
        },
        extras: {
          titleDE: "Extras",
          titleEN: "Extras",
          services: [
            { 
              nameDE: "Wimpern Färben", 
              nameEN: "Eyelash Tinting", 
              price: "7€"
            },
            { 
              nameDE: "Augenbrauen Färben", 
              nameEN: "Eyebrow Tinting", 
              price: "7€"
            },
            { 
              nameDE: "Augenbrauen Zupfen", 
              nameEN: "Eyebrow Plucking", 
              price: "7€"
            },
            { 
              nameDE: "Oberlippe mit Faden Zupfen", 
              nameEN: "Upper Lip Threading", 
              price: "3€"
            },
            { 
              nameDE: "Zupfen ganzes Gesicht mit Fadentechnik", 
              nameEN: "Full Face Threading", 
              price: "15€"
            },
            { 
              nameDE: "OLAPLEX Behandlung", 
              nameEN: "OLAPLEX Treatment", 
              priceDE: "ab 15€",
              priceEN: "from 15€"
            },
            { 
              nameDE: "Haarverlängerung", 
              nameEN: "Hair Extensions", 
              priceDE: "auf Anfrage",
              priceEN: "on request"
            },
            { 
              nameDE: "Keratin Haarglättung", 
              nameEN: "Keratin Hair Straightening", 
              priceDE: "ab 100€",
              priceEN: "from 100€"
            }
          ]
        }
      }
    },
    herren: {
      titleDE: "Herren",
      titleEN: "Men",
      services: [
        { nameDE: "Trocken Schneiden und stylen", nameEN: "Dry Cut and Style", price: "16€" },
        { nameDE: "Waschen Schneiden Föhnen & stylen", nameEN: "Wash Cut Blow-dry & Style", price: "18€" },
        { nameDE: "Maschinenschnitt", nameEN: "Machine Cut", price: "13€" },
        { nameDE: "Neuschnitt", nameEN: "New Cut", price: "20€" },
        { nameDE: "Bartrasur nass", nameEN: "Wet Shave", price: "12€" },
        { nameDE: "Bartrasur mit Maschine", nameEN: "Machine Shave", price: "6€" },
        { nameDE: "Komplett Färben", nameEN: "Complete Coloring", price: "ab 35€" },
        { nameDE: "Oberkopf Dauerwelle mit Spülung", nameEN: "Top Head Perm with Conditioning", price: "ab 30€" },
        { nameDE: "Haarwasser inkl. Massage", nameEN: "Hair Tonic incl. Massage", price: "8€" },
        { nameDE: "Haarkur", nameEN: "Hair Treatment", price: "5€" },
        { nameDE: "Waschen und stylen", nameEN: "Wash and Style", price: "6€" },
        { nameDE: "Heißwax Ohren & Nase", nameEN: "Hot Wax Ears & Nose", price: "6€" },
        { nameDE: "Nacken", nameEN: "Neck", price: "5€" }
      ]
    },
    kinder: {
      titleDE: "Kinder",
      titleEN: "Children",
      services: [
        { nameDE: "Junge bis 8 Jahren", nameEN: "Boy up to 8 years", price: "12€" },
        { nameDE: "Von 9 bis 11 Jahren", nameEN: "From 9 to 11 years", price: "14€" },
        { nameDE: "Mädchen bis 8 Jahren", nameEN: "Girl up to 8 years", price: "15€" },
        { nameDE: "Von 9 bis 11 Jahren", nameEN: "From 9 to 11 years", price: "18€" }
      ]
    }
  };

  const toggleCategory = (category) => {
    setOpenCategory(openCategory === category ? null : category);
  };

  const toggleSubcategory = (subcategory) => {
    setOpenSubcategory(openSubcategory === subcategory ? null : subcategory);
  };

  const renderService = (service) => {
    const serviceName = language === 'de' ? service?.nameDE : service?.nameEN;
    let servicePrice = service?.price;
    
    if (service?.priceDE && service?.priceEN) {
      servicePrice = language === 'de' ? service?.priceDE : service?.priceEN;
    }
    
    if (service?.sizes) {
      return (
        <div key={serviceName} className="flex items-start justify-between py-2 border-b border-secondary/20 last:border-b-0">
          <div className="flex flex-col">
            <span className="font-body text-white">{serviceName}</span>
            <span className="font-body text-xs text-white/60">{service?.sizes}</span>
          </div>
          <span className="font-body font-semibold text-secondary">{servicePrice}</span>
        </div>
      );
    }
    
    return (
      <div key={serviceName} className="flex items-center justify-between py-2 border-b border-secondary/20 last:border-b-0">
        <span className="font-body text-white">{serviceName}</span>
        <span className="font-body font-semibold text-secondary">{servicePrice}</span>
      </div>
    );
  };

  return (
    <section id="services" className="py-16 lg:py-24 bg-primary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-secondary mb-4">
            {content?.[language]?.title}
          </h2>
          <p className="font-body text-lg text-white/80">
            {content?.[language]?.subtitle}
          </p>
        </div>

        {/* Services Categories */}
        <div className="space-y-6">
          {Object.entries(services)?.map(([categoryKey, category]) => (
            <div key={categoryKey} className="bg-secondary/10 rounded-xl overflow-hidden">
              <button
                onClick={() => toggleCategory(categoryKey)}
                className="w-full px-6 py-4 flex items-center justify-between hover:bg-secondary/20 transition-luxury"
              >
                <h3 className="font-heading font-bold text-xl text-secondary">
                  {language === 'de' ? category?.titleDE : category?.titleEN}
                </h3>
                {openCategory === categoryKey ? 
                  <ChevronUp size={24} className="text-secondary" /> : 
                  <ChevronDown size={24} className="text-secondary" />
                }
              </button>
              
              {openCategory === categoryKey && (
                <div className="px-6 pb-6">
                  {/* Ladies subcategories */}
                  {categoryKey === 'damen' && category?.subcategories ? (
                    <div className="space-y-4">
                      {Object.entries(category?.subcategories)?.map(([subKey, subcategory]) => (
                        <div key={subKey} className="bg-primary/20 rounded-lg overflow-hidden">
                          <button
                            onClick={() => toggleSubcategory(subKey)}
                            className="w-full px-4 py-3 flex items-center justify-between hover:bg-primary/30 transition-luxury"
                          >
                            <h4 className="font-heading font-semibold text-lg text-secondary">
                              {language === 'de' ? subcategory?.titleDE : subcategory?.titleEN}
                            </h4>
                            {openSubcategory === subKey ? 
                              <ChevronUp size={20} className="text-secondary" /> : 
                              <ChevronDown size={20} className="text-secondary" />
                            }
                          </button>
                          
                          {openSubcategory === subKey && (
                            <div className="px-4 pb-4">
                              <div className="space-y-3">
                                {subcategory?.services?.map((service, index) => (
                                  <div key={index}>
                                    {renderService(service)}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    /* Other categories (Herren, Kinder) */
                    <div className="space-y-3">
                      {category?.services?.map((service, index) => (
                        <div key={index}>
                          {renderService(service)}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;